import { useFetch, useListFetch } from '../../hooks';
import { getCampaignMonitoring, getCampaignMetrics } from '../../api';
import type { CampaignMonitoringItemType } from '../../api';
import type { GetCampaignMonitoringFilters } from '../../api';

export const useCampaignMonitoring = () => {
  const result = useListFetch<
    CampaignMonitoringItemType,
    GetCampaignMonitoringFilters
  >(
    async params => {
      const content = await getCampaignMonitoring(params?.filters || {});

      return { content };
    },
    { initialFilters: { campaignId: '' }, withQueryParams: true }
  );

  const { data: metrics } = useFetch(
    () => getCampaignMetrics(result.filters || {}),
    [result.filters]
  );

  return { ...result, metrics };
};
